export default [
    {
        avatarSrc : "https://cdn-icons-png.flaticon.com/512/2494/2494271.png",
        title : "Connect Us",
        description : "Connect Us is an end to end video conferencing webapp that uses WebRTC framework to provide peer to peer connection between participants for video and audio conferencing.",
        imgSrc : "https://cdn-icons-png.flaticon.com/512/3214/3214781.png",
        codeUrl : "https://github.com/aryaman0098/Connect-Us"        
    },
    {
        avatarSrc : "https://i.pinimg.com/originals/80/74/17/8074177f317194ce8a6ad2ef4002342b.png",
        title : "Movie Recommender Engine",
        description : "End to end content based movies recommendation system using TFIDF and cosine similarity for finding similar movies.",
        imgSrc : "https://cdn.dribbble.com/users/4017506/screenshots/9716589/media/e7091a962219fa655ae0fddb25f1adfa.png?compress=1&resize=400x300",
        codeUrl : "https://github.com/aryaman0098/Movie-Recommender-Engine"
    },
    {
        avatarSrc : "https://mpng.subpng.com/20180320/jcw/kisspng-circle-brand-symbol-font-app-terminal-5ab0ebeebfe475.547184531521544174786.jpg",
        title : "Unix Type Shell",
        description : "Unix Types Shell developed in C language supporting all system commands.",
        imgSrc : "https://ubuntucommunity.s3.dualstack.us-east-2.amazonaws.com/original/2X/5/5249bad7f0bb536adceb8a9381c7366054546763.png",
        codeUrl : "https://github.com/aryaman0098/Unix-Type-Shell"
    },
    {
        avatarSrc : "https://cdn6.f-cdn.com/contestentries/1495191/29595932/5ccbbc32d8b58_thumb900.jpg",
        title : "Sudoku Game",
        description : "Sudoku game developed using QT framework and written in C++ with 3 different levels.",
        imgSrc : "https://i.pinimg.com/originals/36/ae/6a/36ae6a9e11c2d55bd2f25b6c8b672e00.jpg",
        codeUrl : "https://github.com/aryaman0098/Sudoku"
    },
    {
        avatarSrc : "https://i.pinimg.com/originals/80/74/17/8074177f317194ce8a6ad2ef4002342b.png",
        title : "Face Mask Detection",
        description : "Face mask detection software which makes use of CNN to detect mask on the face of a subject.",
        imgSrc : "https://previews.123rf.com/images/sirajahmad/sirajahmad2005/sirajahmad200500064/146302265-man-with-face-mask-icon-vector-illustration.jpg",
        codeUrl : "https://github.com/aryaman0098/Face-Mask-Detection"
    },
    {
        avatarSrc : "https://i.pinimg.com/originals/80/74/17/8074177f317194ce8a6ad2ef4002342b.png",
        title : "Neural Style Transfer",
        description : "Implemeted the research paper A Neural Algorithm of Artistic Style, with few extensions of my own.",
        imgSrc : "https://analyticsindiamag.com/wp-content/uploads/2020/06/1_kOQOZxBDNw4lI757soTEyQ.png",
        codeUrl : "https://github.com/aryaman0098/Neural-Style-Transfer"
    }
]